<template>
  <transition name="fade" mode="out-in" id="app">
    <!-- <router-view></router-view> -->
    <router-view v-if="isRouterAlive" />
  </transition>
</template>
<script>
  export default{
    name:'app',
    provide (){
      return{
        reload: this.reload
      }
    },
    data(){
      return{
        isRouterAlive: true
      }
    },
    methods:{
      reload(){
        this.isRouterAlive = false
        this.$nextTick(function(){
          this.isRouterAlive = true
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// app.vue?79302f44